import IconButton from '@mui/material/IconButton'
import { Theme, styled } from '@mui/material/styles'

export const NumberSelectorWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const NumberSelectorLabel = styled('span')`
  margin-right: 3px;
`

export const NumberSelectorValue = styled('span')`
  margin: 0 3px;
  color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  font-weight: 700;
`
export const NumberSelectorSelectIcon = styled(IconButton)`
  padding: 0;
`

export const NumberSelectorIconButtonWrapper = styled('button')`
  background: none;
  border: none;
  padding: 0;
`

export const NumberSelectorIconButton = styled(NumberSelectorSelectIcon)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`
